<mat-toolbar color="accent">
  <span class="w-full">Email {{ data.contact.key }}</span>
</mat-toolbar>

<form [formGroup]="emailForm" (ngSubmit)="submit()">
  <mat-dialog-content>
    <pr-practice-selector
      class="w-full"
      label="Send From"
      formControlName="practice"
      [brands]="brands$ | async"
    />

    <mat-form-field class="w-full">
      <mat-label>Subject</mat-label>
      <input matInput formControlName="subject" />
    </mat-form-field>

    <mat-form-field subscriptSizing="dynamic" class="w-full">
      <mat-label>Email Message</mat-label>
      <pr-content-editor
        placeholder="Email Message"
        format="email"
        formControlName="content"
        [menuEnabled]="false"
        (metaKeydownEvent)="submit()"
      />
    </mat-form-field>

    <div class="flex items-center justify-between gap-4">
      <pr-template-selector
        [templates]="(templates$ | async)?.templates"
        [contextOptions]="(templates$ | async)?.contextOptions"
        [resetOnSelection]="true"
        (templateSelected)="templateSelected($event)"
      />

      <button
        type="button"
        mat-icon-button
        matTooltip="Attach files"
        [matMenuTriggerFor]="attachMenu"
      >
        <mat-icon>attach_file</mat-icon>
      </button>
      <mat-menu #attachMenu="matMenu">
        <button mat-menu-item (click)="onUploadFile()">
          <mat-icon>cloud_upload</mat-icon>
          <span>Upload File</span>
        </button>
        @if (showPatientFileOption) {
          <button mat-menu-item (click)="onPatientFileSelect()">
            <mat-icon>photo_library</mat-icon>
            <span>Patient File</span>
          </button>
        }
      </mat-menu>
    </div>

    @if (fileAttachments.length || mediaAttachments.length) {
      <div class="mt-2 py-2">
        <mat-chip-set class="flex flex-wrap gap-1">
          @for (file of fileAttachments; track file.name; let index = $index) {
            <mat-chip (removed)="removeFileAttachment(index)">
              <mat-icon matChipAvatar>cloud_upload</mat-icon>
              {{ file.name }}
              <span class="text-xs text-gray-500">{{
                file.size | fileSize
              }}</span>
              <button matChipRemove><mat-icon>cancel</mat-icon></button>
            </mat-chip>
          }
          @for (
            media of mediaAttachments;
            track media.ref.path;
            let index = $index
          ) {
            <mat-chip (removed)="removeMediaAttachment(index)">
              <mat-icon matChipAvatar>photo_library</mat-icon>
              {{ media.name }}
              <span class="text-xs text-gray-500">{{
                media | map: getMediaSize | fileSize
              }}</span>
              <button matChipRemove><mat-icon>cancel</mat-icon></button>
            </mat-chip>
          }
        </mat-chip-set>
      </div>
    }
  </mat-dialog-content>

  <input
    #fileInput
    type="file"
    hidden
    multiple
    (change)="onFilesSelected($event)"
  />

  <mat-dialog-actions>
    <div class="flex w-full items-center justify-between gap-4">
      @if (fileAttachments.length && showPatientFileOption) {
        <mat-checkbox
          class="w-full"
          formControlName="saveAttachmentsToPatientFiles"
        >
          Save attachments to patient files
        </mat-checkbox>
      }
      <pt-buttons-container class="w-full" padding="none">
        <button type="button" mat-stroked-button (click)="dialogRef.close()">
          Close
        </button>
        <pt-loader-button
          color="primary"
          type="flat"
          [loading]="submitting$ | async"
          [disabled]="isDisabled$ | async"
          (click)="submit()"
        >
          Send
        </pt-loader-button>
      </pt-buttons-container>
    </div>
  </mat-dialog-actions>
</form>
